import { Fieldset, Radio, RadioGroup, TextField } from '@servicetitan/anvil2-react-hook-form';
import { useFormContext, useWatch } from 'react-hook-form';
import { MailingAddressFields } from '../mailing-address/MailingAddressFields';
import { ApplicationDataStore } from '../application/ApplicationDataStore';
import { ImprovementTypeCombobox } from '../common/ImprovementTypeCombobox';

export const ServicePropertyFields = () => {
    const housingType = useWatch({ name: 'primaryApplicant.housingType' });
    const { applicationData } = ApplicationDataStore.useStore();
    const { register } = useFormContext();

    return (
        <Fieldset legend="Service Property Information">
            <RadioGroup
                legend="Do you own or rent?"
                gridColumn="1/3"
                name="primaryApplicant.housingType"
                required
            >
                <Radio value="own" label="Own" name="primaryApplicant.housingType" />
                <Radio value="rent" label="Rent" name="primaryApplicant.housingType" />
            </RadioGroup>
            {housingType === 'own' && (
                <TextField
                    name="primaryApplicant.monthlyHousingPayment"
                    label="Monthly Mortgage Amount"
                    gridColumn="1/2"
                    prefix="$"
                    type="number"
                    inputMode="decimal"
                    required
                />
            )}
            <RadioGroup
                legend="Property Type"
                gridColumn="1/3"
                name="primaryApplicant.propertyType"
                required
            >
                <Radio
                    value="singleFamily"
                    label="Single Family"
                    name="primaryApplicant.propertyType"
                />
                <Radio
                    value="manufacturedHome"
                    label="Manufactured Home"
                    name="primaryApplicant.propertyType"
                />
            </RadioGroup>
            <ImprovementTypeCombobox style={{ maxWidth: 420 }} gridColumn="1/3" />
            {!(applicationData.mailingAddress?.workPerformedAtAddress ?? true) && (
                <MailingAddressFields />
            )}
            {/* Need this hidden input to ensure we can validate based on the checkbox value */}
            <input type="hidden" {...register('workPerformedAtAddress')} />
        </Fieldset>
    );
};
